import './ListItems.css';

export interface ListItemsProps {
  items: string[];
}

export function ListItems({ items }: Readonly<ListItemsProps>) {
  return (
    <ul className="c-listItems">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default ListItems;
